import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import {
  FOOTER_HEIGHT,
  HEAD_HEIGHT,
} from '@/components/Ad/SliderWithGallery/SliderWithGallery.constants';
import { ellipsisMultiline } from '@/styles/helpers';

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10100;
  width: 100%;
  background-color: #000;
  height: ${HEAD_HEIGHT}px;
`;

export const CountGallery = styled(Typography.Title)<{ $isBig: boolean }>`
  color: ${({ theme }) => theme.palette.system.white};

  ${({ $isBig }) =>
    $isBig &&
    css`
      flex-grow: 1;
      text-align: center;
      transform: translateX(-18px);
    `}
`;

export const Footer = styled.div`
  position: fixed;
  z-index: 10100;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 15px;
  display: grid;
  grid-template-columns: 1fr 50px;
  gap: 20px;
  background-color: #000;
  height: ${({ theme }) =>
    theme.isWebView
      ? `${+theme.insetsBottom + FOOTER_HEIGHT}px`
      : `${FOOTER_HEIGHT}px`};
`;

export const Price = styled(Typography.Header).attrs(() => ({
  $variant: '2',
}))`
  color: ${({ theme }) => theme.palette.system.white};
  margin-bottom: 2px;
`;

export const Description = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))`
  ${ellipsisMultiline(2)}
  color: ${({ theme }) => theme.palette.system.white};
`;

export const CallButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-color: ${({ theme }) => theme.palette.system.green};
  border-radius: 50%;
`;
